import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/app/providers';
import { APP_ROUTES } from '@/config/constants';
import { Spinner } from '@/components/feedback';

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * AuthGuard - Protects routes that require authentication
 *
 * - Shows loading spinner while checking auth
 * - Redirects to signin if not authenticated
 * - Preserves the attempted URL for redirect after login
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  // Redirect to signin if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.SIGNIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
